export default __webpack_public_path__ + "static/media/char_head_002.1c8b4b03.png";